import { useQuery } from '@tanstack/react-query';
import type { AgentApiCandidateProfilesIndex } from '@/types/serializers';

/**
 * KPI カード用に「稼動求職者」の総件数のみを取得する軽量フック。
 * candidate_profiles index API を 1 ページ目だけ叩き、`total_count` のみ参照する。
 */
export default function useFetchCandidateCount() {
  return useQuery({
    queryKey: ['/agent/api/candidate_profiles', 'count'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_profiles.json?page=1');
      if (!response.ok) {
        throw new Error('稼動求職者数の取得に失敗しました');
      }
      const data: AgentApiCandidateProfilesIndex = await response.json();
      return data.total_count;
    },
  });
}
